<template>
  <v-container id="profile-page">
    <v-card class="pa-10">
      <div class="_fs-36">
        ข้อมูลสำหรับออกใบกำกับภาษี
      </div>
      <div>จัดการข้อมูลในการออกใบกำกับภาษีสำหรับบริษัทนี้</div>

      <v-divider class="my-4"></v-divider>

      <v-row>
        <!-- <v-col
          cols="6"
          md="2"
          class="d-flex align-center justify-center">
          <v-avatar size="100">
            <v-img :src="userProfile.pictureUrl"></v-img>
          </v-avatar>
        </v-col> -->

        <v-col
          cols="6"
          md="10"
          class="d-flex flex-column justify-center">
          <div>
            <span class="font-weight-bold">Display Name:</span>
            <br class="d-md-none">
            <span class="primary--text">
              {{ activeLineOfficialAccount.displayName }}
            </span>
          </div>
          <div>
            <span class="font-weight-bold">Basic ID:</span>
            <br class="d-md-none">
            <span class="primary--text">
              {{ activeBasicId }}
            </span>
          </div>
        </v-col>
      </v-row>

      <p class="mt-4 _fs-20">
        ข้อมูลร้านค้า หรือบริษัท
      </p>
      <div>
        ประเภทผู้เสียภาษี
        <span class="d-block d-md-inline-block primary--text font-weight-bold">
          {{ $utils.customerTypeText(customerTypes, activeLineOfficialAccount.customerTypeId) }}
        </span>
      </div>

      <div v-if="isJuristicCustomer">
        เลขที่สาขา
        <span class="d-block d-md-inline-block font-weight-bold">
          {{ activeLineOfficialAccount.branchNumber }}
          <template v-if="$utils.isHeadquarter(activeLineOfficialAccount.branchNumber)">
            (สำนักงานใหญ่)
          </template>
        </span>
      </div>

      <div v-if="isJuristicCustomer">
        {{ $utils.citizenIdText(isJuristicCustomer) }}
        <span class="d-block d-md-inline-block font-weight-bold">
          {{ activeLineOfficialAccount.citizenId }}
        </span>
      </div>

      <div>
        ชื่อร้านค้าหรือบริษัท
        <span class="d-block d-md-inline-block font-weight-bold">
          {{ activeLineOfficialAccount.companyName }}
        </span>
      </div>

      <p class="mt-4 _fs-20">
        ข้อมูลร้านค้า หรือบริษัท
      </p>
      <v-row no-gutters>
        <v-col cols="6">
          ชื่อ
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.firstName }}</span>
        </v-col>
        <v-col cols="6">
          นามสกุล
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.lastName }}
          </span>
        </v-col>
        <v-col cols="6">
          Email สำหรับส่งใบกำกับภาษี
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.email }}
          </span>
        </v-col>
        <v-col cols="6">
          Email สำหรับส่งใบเสนอราคา
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.emailQuotation }}
          </span>
        </v-col>
        <v-col cols="6">
          โทรศัพท์
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.tel }}
          </span>
        </v-col>
      </v-row>

      <p class="mt-4 _fs-20">
        ที่อยู่ของร้านค้า หรือบริษัท
      </p>
      <v-row no-gutters>
        <v-col cols="12">
          ที่อยู่
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.address }}
          </span>
        </v-col>
        <v-col cols="6">
          ถนน
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.street }}
          </span>
        </v-col>
        <v-col cols="6">
          แขวง/ตำบล
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.subdistrict }}
          </span>
        </v-col>
        <v-col cols="6">
          เขต/อำเภอ
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.district }}
          </span>
        </v-col>
        <v-col cols="6">
          จังหวัด
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.stateProvince }}
          </span>
        </v-col>
        <v-col cols="6">
          รหัสไปรษณีย์
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ activeLineOfficialAccount.zipCode }}
          </span>
        </v-col>
      </v-row>
    </v-card>

    <div class="text-center my-8">
      <v-btn
        color="primary"
        rounded
        outlined
        min-width="150"
        :to="{ name: 'ProfileEdit' }">
        <v-icon left>
          mdi-pencil
        </v-icon>
        แก้ไขข้อมูล
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ProfilePage',
  data () {
    return {
      customerType: 'normal',
      packageStartedMenu: false,
      packageStartedAt: ''
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapState('CustomerType', ['customerTypes']),
    ...mapGetters({
      activeBasicId: 'User/activeBasicId',
      activeLineOfficialAccount: 'User/activeLineOfficialAccount'
    }),
    isJuristicCustomer () {
      return this.$utils.isJuristicCustomer(this.activeLineOfficialAccount.customerTypeId)
    }
  }
}
</script>
